module.exports = __webpack_public_path__ + "static/media/details.568dfb9f.jpg";